// removed by extract-text-webpack-plugin
module.exports = {"form_wrapper":"_91jJW","form_name":"_1aRs4","form_select":"_13cZX","form_select_dropdown":"_1rXXB","form_input":"_24jV9","form_btn_wrapper":"_2TY4p","form_collapse":"_29Pv8","button":"vklyE","btn_primary":"_1p9lc vklyE _1p9lc vklyE","btn_secondary":"_2J5U7 vklyE","btn_warning":"_1MFmF _2J5U7 vklyE _1MFmF _2J5U7 vklyE","root":"_228Uq","input_wrapper":"_3hae- _91jJW","input_name":"_1PsKo _1aRs4","text_input":"_1VBoj _24jV9","button_wrapper":"_1y3od _2TY4p"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/templates/NewTemplate.css
// module id = 917
// module chunks = 0